export const QUICK_SUMMARY_FEEDBACK_ENTRYPOINT_ID = 'd44ea02e-f7d1-491c-b061-53405badbbd3';

export const WHITEBOARDS_SUMMARY_FEEDBACK_ENTRYPOINT_ID = '6907be36-5bd3-4f79-be18-6be58d6ff0da';
